import React from "react";

import { SelectableColumnTable } from "app/interaction/SelectableColumnTable/SelectableColumnTable";
import { Box } from "app/layout/components";
import { dynamicFormatDecimal } from "app/formatting/functions";
import { friendlyCurrency } from "app/main/currencyFunctions";

import { FinanceKnowledgeContainer } from "app/financeKnowledge/FinanceKnowledgeContainer/FinanceKnowledgeContainer";
import { SectionHeader } from "app/layout/SectionHeader/SectionHeader/SectionHeader";

export interface Props {
    currency: string;
    /** Array of objects that represent each column. */
    children: {
        label: string;
        items: number[];
    }[];
}

/**
 * Renders a table that shows the profit and loss for three years.
 * On mobile, the table shows only the values for _one_ year and alongside
 * a button component to select the year.
 */
export const ProfitAndLoss = ({ children, currency }: Props) => {
    // Convert all numeric items into money formatted strings.
    const formattedData = children.map(c => ({ ...c, items: c.items.map(n => (n ? dynamicFormatDecimal(n) : null)) }));

    return (
        <Box section>
            <SectionHeader headline="Gewinn und Verlust" />
            <FinanceKnowledgeContainer knowledgeKey="profitAndLoss" />
            <SelectableColumnTable
                headerLabel="JAHR"
                rowLabels={[
                    "Umsatz (Mio. " + friendlyCurrency(currency) + ")",
                    "Nettogewinn (Mio. " + friendlyCurrency(currency) + ")"
                ]}
            >
                {formattedData}
            </SelectableColumnTable>
        </Box>
    );
};
